<template>
  <div class="yxtbiz-tmap-audit">
    <yxt-form
      label-position="top"
      label-width="auto"
    >
      <yxt-form-item :label="$t('pc_biz_tmap_lbl_name').d('层级地图名称')">
        <p>{{ mapDetails.trainMapName }}</p>
      </yxt-form-item>
      <yxt-form-item :label="$t('pc_biz_kng_detail_lbl_introduction').d('简介')">
        <p>{{ mapDetails.description || '-' }}</p>
      </yxt-form-item>
    </yxt-form>
    <xxbiz-signup
      v-if="!isSignup"
      mod="info"
      :id="id"
      @callback="callback"
    ></xxbiz-signup>
  </div>
</template>

<script>
import { getMapInfo } from './service';

export default {
  name: 'YxtbizTmapAudit',
  props: {
    id: {
      type: String,
      default: ''
    },
    isSignup: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      mapDetails: {}
    };
  },
  watch: {
    id: {
      handler(val) {
        if (val) {
          if (this.isSignup) {
            this.getMap(val);
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    callback(id, data) {
      if (data && data.projectId) {
        this.getMap(data.projectId);
      }
    },
    async getMap(id) {
      const mapInfo = await getMapInfo(id);
      this.mapDetails = mapInfo;
    }
  }
};
</script>
